import { GenericService } from './generic.service';
import { Clinic } from '@/models';

export class OrganisationClinicService extends GenericService<Clinic> {

  constructor(organisationId: string) {
    super(`v1/organisations/${organisationId}/clinics`);
  }
}
